export default __webpack_public_path__ + "static/media/icon-petco.0e3691cc.png";